"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEmptyMessageRenderer = void 0;
const react_1 = __importDefault(require("react"));
const Text_1 = require("../../Text");
const View_1 = require("../../View");
const OptionRoot_1 = require("../OptionRoot");
const createEmptyMessageRenderer = ({ text }) => {
    return function emptyMessageRenderer() {
        return (react_1.default.createElement(OptionRoot_1.OptionRoot, { spaceVertical: View_1.INDENT.s },
            react_1.default.createElement(Text_1.Text, { view: Text_1.TEXT_VIEW.secondary, truncate: true }, text)));
    };
};
exports.createEmptyMessageRenderer = createEmptyMessageRenderer;
//# sourceMappingURL=emptyMessageRenderer.js.map